var map = {
	"./arrow-down.svg": 25323,
	"./arrow-up.svg": 3981,
	"./audio-music.svg": 93669,
	"./back-icon.svg": 74681,
	"./bell.svg": 19178,
	"./biggan-chinta.svg": 28291,
	"./bondhushava.svg": 43006,
	"./bookmark-outline.svg": 78411,
	"./close-white.svg": 36641,
	"./close.svg": 39525,
	"./comments-outline.svg": 53045,
	"./default-author-image.svg": 39191,
	"./default-card-image.svg": 31763,
	"./envelope.svg": 18163,
	"./fb-blue.svg": 46158,
	"./fb-whitebg.svg": 70238,
	"./fb.svg": 33836,
	"./fullscreen-exit.svg": 25291,
	"./fullscreen.svg": 65204,
	"./gallery-scope.svg": 62384,
	"./google-g.svg": 13308,
	"./google-icon.svg": 20557,
	"./interview.svg": 36048,
	"./kishoralo-white.svg": 13935,
	"./kishoralo.svg": 2992,
	"./launcher.svg": 55151,
	"./media-placeholder.svg": 86034,
	"./messenger.svg": 10255,
	"./nagorik.svg": 64918,
	"./next-story.svg": 67641,
	"./palo-bangla.svg": 89249,
	"./palo-english.svg": 81993,
	"./photo-camera.svg": 83827,
	"./pinned-icon.svg": 60466,
	"./prayer-header.svg": 20975,
	"./prayer-sunrise.svg": 69173,
	"./prothomalo-com.svg": 79055,
	"./prothomalo-trust.svg": 63462,
	"./protichinta-logo.svg": 95221,
	"./refresh-icon.svg": 35448,
	"./search.svg": 66759,
	"./shorts.svg": 67728,
	"./sun.svg": 74060,
	"./tv.svg": 29145,
	"./twitter-whitebg.svg": 98762,
	"./video-play.svg": 58645,
	"./visual-story.svg": 76221
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51006;